import KliraCartCoupon from '../obj/KliraCartCoupon.js';
import KliraCartItem from '../obj/KliraCartItem.js';

const journeyMap = {
        201: {
        label: "OILY & HYPERPIGMENTED SKINSIZES",
        image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0002_Layer-Comp-3-scaled.jpg"
    },
    202: {
        label: "OILY & NON-HYPERPIGMENTED SKINSIZES",
        image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0003_Layer-Comp-4-scaled.jpg"
    },
    203: {
        label: "DRY & HYPERPIGMENTED SKINSIZES",
        image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0000_Layer-Comp-1.jpg"
    },
    204: {
        label: "DRY & NON-HYPERPIGMENTED SKINSIZES",
        image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0001_Layer-Comp-2-scaled.jpg"
    }
};

// add cart globally accessible through window object
window.cart = {
  items: [], // array of KliraCartItem
  coupons: [], // array of KliraCartCoupon
  couponError: null,

  buildLineItems: function () {
    return this.items.map((item) => {
      const additionalFields = item.getAdditionalFields();
      const journey_id = additionalFields.journey_id;

      return {
        id: item.getProduct().id,
        plan_id: item.getProduct().chargebeePlanId,
        addon_id: item.getProduct().chargebeeAddOnId,
        quantity: item.quantity,
        additional_fields: {
          ...additionalFields,
          journey_id: journey_id || null,
          journey_label: journeyMap?.journey_id?.label || null,
          journey_image: journeyMap?.journey_id?.label || null,
        },
      };
    });
  },

  buildCouponItems: function () {
    return this.coupons.map((item) => item.code);
  },
  addCoupon: async function (code) {
    try {
      // remove any existing errors
      this.couponError = null;

      let existingCouponCount = this.coupons.length;

      let coupon = new KliraCartCoupon(code);

      if (this.hasCoupon(coupon)) {
        // coupon is already applied
        this.couponError = `Coupon ${coupon.code} is already applied`;
        return false;
      }

      console.log("CART: Pushing", coupon.code, "into cart coupons");
      this.coupons.push(coupon);

      let recalculated = await this.recalculateCoupons();

      // save the cart
      console.log("CART: Saving after addCoupon");
      this.save();

      let newCouponCount = this.coupons.length;

      if (newCouponCount === existingCouponCount) {
        // same number of coupons as before, it didn't add this.
        return false;
      }

      return recalculated;
    } catch (error) {
      console.error("ERROR: ", error);
    }
  },
  removeCoupon: async function (code) {
    console.log("CART: Attempting to remove coupon", code);

    let count = this.coupons.length;

    // if we find this coupon in the cart then remove it
    this.coupons = this.coupons.filter(function (coupon) {
      return coupon.code !== code.toLowerCase();
    });

    if (this.coupons.length === count) {
      // no coupons removed, no need to recalculate
      return;
    }

    // get the prices with the new set of coupons
    let recalculated = await this.recalculateCoupons();

    // save the cart
    console.log("CART: Saving after removeCoupon");
    this.save();

    return recalculated;
  },
  recalculateCoupons: async function () {
    console.log("CART: Recalculating cost with coupons");

    if (this.coupons.length === 0) {
      console.log("CART: No coupons, no discounts to apply");
      return true;
    }

    const responseJson = await window.utils.request.post(
      `/wp-json/klira/checkout/estimate`,
      {
        items: this.buildLineItems(),
        coupons: this.buildCouponItems(),
      }
    );

    let responseObj = JSON.parse(responseJson);

    if (!responseObj.success) {
      this.couponError = responseObj.message;
      return false;
    }

    // remove any coupons that aren't in the response
    this.coupons = this.coupons.filter(function (coupon) {
      let found = false;
      let discountAmount = 0;

      responseObj.discounts.forEach(function (returnedDiscount) {
        if (returnedDiscount.code.toLowerCase() === coupon.code) {
          // add the discount for this code on this product
          discountAmount += Number(returnedDiscount.discount_amount);
          found = true;
        }
      });

      coupon.discountAmount = discountAmount;

      return found;
    });

    return true;
  },

  hasMultipleChargeItems: function () {
    let chargeCount = 0;

    this.items.forEach(function (item) {
      if (item.product.isCharge) {
        chargeCount++;
      }
    });

    return chargeCount > 1;
  },
  hasCoupon: function (coupon) {
    let hasCoupon = false;

    if (!coupon.code) {
      return hasCoupon;
    }

    this.coupons.forEach(function (item) {
      if (item.code === coupon.code) {
        hasCoupon = true;
      }
    });

    console.log(
      "CART: Coupon",
      coupon.code,
      hasCoupon ? "is" : "is not",
      "in cart"
    );

    return hasCoupon;
  },
  addItem: async function (product, quantity, additionalFields) {
    console.log(
      "CART: Adding product with ID = ",
      product.id,
      ", PlanID =",
      product.chargebeePlanId,
      ", AddonID =",
      product.chargebeeAddOnId,
      additionalFields,
      "to cart"
    );

    if (product.isSubscription) {
      // Remove only same-type subscriptions
      if (product.isNightCream) {
        await this.removeNightCreamSubscription();
      } else if (product.isBody) {
        await this.removeBodySubscription();
      } else if (product.isDayScript) {
        await this.removeDayScriptSubscription();
      }
    }

    if (product.isEachItemUnique || !this.hasItem(product)) {
      // it's not in the cart, add it
      let item = new KliraCartItem(product, quantity, additionalFields);
      console.log(
        "CART: Pushing product with ID = ",
        product.id,
        ", PlanID =",
        product.chargebeePlanId,
        ", AddonID =",
        product.chargebeeAddOnId,
        item.additionalFields,
        "into cart items"
      );
      this.items.push(item);

      console.log("CART: auto applying any coupons");
      await this.autoApplyCoupons();
      await this.recalculateCoupons();
    } else if (this.hasItem(product) && !product.canBuyMultiple) {
      console.log(
        "CART: Item is already in cart and you cannot buy multiple, not adding anything to cart"
      );
    } else {
      console.log("CART: Item is already in cart, incrementing quantity");
      // it's already in the cart - increment quantity of this item
      this.items.forEach(function (item) {
        if (item.getProduct().chargebeeAddOnId === product.chargebeeAddOnId) {
          item.quantity++;
        }
      });

      await this.recalculateCoupons();
    }

    // save the cart
    console.log("CART: Saving after addItem");
    this.save();
  },
  removeItem: async function (cartItemId) {
    console.log("CART: Attempting to remove", cartItemId);

    // if we find this product in the cart then remove it
    this.items = this.items.filter(function (item) {
      return item.uid !== cartItemId;
    });

    await this.autoApplyCoupons();

    // if no extra coupons were applied we will need to recalculate the existing
    // ones, to remove any that are no longer valid
    await this.recalculateCoupons();

    // save the cart
    console.log("CART: Saving after removeItem");
    this.save();
  },
  removeNightCreamSubscription: async function () {
    console.log("CART: Attempting to remove night cream subscription");

    // if we find night cream sub in the cart then remove it
    this.items = this.items.filter(function (item) {
      return !item.getProduct().isNightCream;
    });

    await this.autoApplyCoupons();

    // save the cart
    console.log("CART: Saving after removeNightCreamSubscription");
    this.save();
  },
  removeBodySubscription: async function () {
    console.log("CART: Attempting to remove body subscription");

    // if we find body sub in the cart then remove it
    this.items = this.items.filter(function (item) {
      return !item.getProduct().isBody;
    });

    await this.autoApplyCoupons();

    // save the cart
    console.log("CART: Saving after removeBodySubscription");
    this.save();
  },
  removeDayScriptSubscription: async function () {
    console.log("CART: Attempting to remove day script subscription");

    // if we find day script sub in the cart then remove it
    this.items = this.items.filter(function (item) {
      return !item.getProduct().isDayScript;
    });

    await this.autoApplyCoupons();

    // save the cart
    console.log("CART: Saving after removeDayScriptSubscription");
    this.save();
  },
  removeCharge: async function () {
    console.log("CART: Attempting to remove charge item");

    // if we find charge sub in the cart then remove it
    this.items = this.items.filter(function (item) {
      return !item.getProduct().isCharge;
    });

    await this.autoApplyCoupons();

    // save the cart
    console.log("CART: Saving after removeCharge");
    this.save();
  },
  hasItem: function (product) {
    let hasItem = false;

    this.items.forEach(function (item) {
      if (item.getProduct().id === product.id) {
        hasItem = true;
      }
    });

    console.log("CART: Item", product.id, hasItem ? "is" : "is not", "in cart");

    return hasItem;
  },
  empty: function () {
    this.items = [];
    this.coupons = [];
    console.log("CART: Saving after empty");
    this.save();
  },
  isEmpty: function () {
    return this.getItemCount() === 0;
  },
  getItemCount: function () {
    return this.items.length;
  },
  cartContainsNightCream: function () {
    return this.items.some(function (item) {
      let product = item.getProduct();
      return product.isNightCream && product.isSubscription;
    });
  },
  cartContainsBody: function () {
    return this.items.some(function (item) {
      let product = item.getProduct();
      return product.isBody && product.isSubscription;
    });
  },
  cartContainsDayScript: function () {
    return this.items.some(function (item) {
      let product = item.getProduct();
      return product.isDayScript && product.isSubscription;
    });
  },
  getTotalPrice: function () {
    let total = 0;

    this.items.forEach(function (item) {
      total += item.getTotalPrice();
    });

    return total;
  },
  areCouponsApplied: function () {
    return this.coupons.length > 0;
  },
  getDiscountedPrice: function () {
    if (!this.areCouponsApplied()) {
      return this.getTotalPrice();
    }

    let total = this.getTotalPrice();
    let discount = 0;

    this.coupons.forEach(function (coupon) {
      discount += coupon.discountAmount;
    });

    return total - discount;
  },
  autoApplyCoupons: async function () {
    console.log("CART: attempting to auto apply coupons");

    if (
      this.cartContainsNightCream() ||
      this.cartContainsBody() ||
      this.cartContainsDayScript()
    ) {
      // only process RAF coupon if the cart already contains an eligible subscription
      let referAFriendCoupon = window.utils.cookies.getCookieValue("raf");

      if (referAFriendCoupon) {
        console.log("CART: Adding referral coupon ", referAFriendCoupon);
        await this.addCoupon(referAFriendCoupon).then(function () {
          console.log("CART: Removing referral coupon cookie");
          window.utils.cookies.removeCookie("raf");
        });
      }
    }

    return false;
  },
  emptyCartOfAlreadyPurchasedItems: async function () {
    if (
      window.customer.subscriptions.hasNightCream() &&
      this.cartContainsNightCream()
    ) {
      // they can't buy what they already have
      await this.removeNightCreamSubscription();
    }

    if (window.customer.subscriptions.hasBody() && this.cartContainsBody()) {
      // they can't buy what they already have
      await this.removeBodySubscription();
    }

    if (
      window.customer.subscriptions.hasDayScript() &&
      this.cartContainsDayScript()
    ) {
      // they can't buy what they already have
      await this.removeDayScriptSubscription();
    }
  },
  postAddToBasket: function (product) {
    let modalOptions = {
      closeOnBackgroundClick: true,
      additionalClasses: ["item-added-to-basket-modal"],
    };

    let modalHtml = `<h1>ADDED TO BASKET</h1><div class="add-to-basket-modal-options"><button class="continue-shopping">Continue shopping</button><button class="go-to-checkout">Checkout</button></div>`;

    window.DigitalNature.modal.open(modalHtml, modalOptions);
  },

  init: async function () {
    // initialises the cart for use
    await this.load();
    this.configureMiniCart();
    this.addEventListeners();
  },
  configureMiniCart: function () {
    // updates the mini cart icon to show no of products
    document
      .querySelectorAll(".cart-icon .elementor-icon")
      .forEach(function (item) {
        if (!window.cart.isEmpty()) {
          item.dataset.total = window.cart.getItemCount();
          item.parentElement.classList.add("is-has");
        } else {
          item.parentElement.classList.remove("is-has");
        }
      });
  },
  addEventListeners: function () {
    // listens for clicks on 'buy now', pulls in the product and adds it to cart
    document.addEventListener("click", async function (event) {
      let addProductToCartClass = "add-product-to-cart";

      if (
        !event.target.matches(`.${addProductToCartClass}`) &&
        !event.target.closest(`.${addProductToCartClass}`)
      ) {
        return true;
      }

      let body = document.querySelector("body");
      window.DigitalNature.utils.animations.addLoadingSpinner(body);

      // if the button has a product ID on it then we use that, otherwise we try to ascertain it from the page
      let addProductToCartElement = event.target.classList.contains(
        addProductToCartClass
      )
        ? event.target
        : event.target.closest(`.${addProductToCartClass}`);
      let productToAdd = window.products.getSelectedProductFromElement(
        addProductToCartElement
      );

      if (!productToAdd) {
        // there was no product on this element itself, look at the rest of the page
        productToAdd = window.products.getSelectedProduct();

        if (!productToAdd) {
          console.error("Buy now button clicked but no product was found");
          window.DigitalNature.utils.animations.removeLoadingSpinner(body);
          return;
        }
      }

      let productAdditionalFields =
        window.products.getSelectedProductAdditionalFields();

      if (window.products.hasAdditionalFieldErrors()) {
        console.error(
          "Cannot add product to cart, there are errors with the additional fields"
        );
        window.DigitalNature.utils.animations.removeLoadingSpinner(body);
        return;
      }

      if (
        productToAdd.isSubscription &&
        ((productToAdd.isNightCream &&
          window.customer.subscriptions.hasNightCream()) ||
          (productToAdd.isBody && window.customer.subscriptions.hasBody()) ||
          (productToAdd.isDayScript &&
            window.customer.subscriptions.hasDayScript()))
      ) {
        // if it's a subscription, and they already have a sub of that type then
        // redirect to subscriptions page and don't add to cart
        window.location.href = "/my-account/subscriptions/";
        return;
      }

      // add product and immediately redirect to check out
      await window.cart.addItem(productToAdd, 1, productAdditionalFields);

     const currentPath  = window.location.pathname;
     const isSubscriptionOrThankYouPage = (currentPath === "/my-account/subscriptions/" || currentPath === "/thank-you/");
     window.DigitalNature.utils.animations.removeLoadingSpinner(body);

     // If product is selected from subscription or thank-you page → redirect to checkout
     if (isSubscriptionOrThankYouPage) {
      window.location.href = "/checkout";
      return;
     }

     // Normal product page no redirect.
     // Basket modal / mini cart will handle the flow.
     return;
    });

    // after adding an item to basket and clicking "continue shopping"
    document.addEventListener("click", async function (event) {
      if (
        !event.target.matches(`.add-to-basket-modal-options .continue-shopping`)
      ) {
        return true;
      }

      window.DigitalNature.modal.close();

      event.preventDefault();

      return false;
    });

    // after adding an item to basket and clicking "checkout"
    document.addEventListener("click", async function (event) {
      if (
        !event.target.matches(`.add-to-basket-modal-options .go-to-checkout`)
      ) {
        return true;
      }
      event.preventDefault();

      window.location.href = "/checkout";

      return false;
    });
  },

  // persist methods
  save: function () {
    console.log("CART: Saving", this.items, this.coupons);
    // save cart items and discounts
    localStorage.setItem("cart/items", JSON.stringify(this.items));
    localStorage.setItem("cart/coupons", JSON.stringify(this.coupons));
  },
  load: async function () {
    console.log("CART: Loading");
    if (localStorage.getItem("cart/items")) {
      // load cart items
      let storedItems = JSON.parse(localStorage.getItem("cart/items"));

      // map through and convert all to KliraCartItem
      this.items = storedItems.map(function (item) {
        return new KliraCartItem(
          item.product,
          item.quantity,
          item.additionalFields
        );
      });
    }

    if (localStorage.getItem("cart/coupons")) {
      // load cart coupons
      let storedItems = JSON.parse(localStorage.getItem("cart/coupons"));

      // map through and convert all to KliraCartCoupon
      this.coupons = storedItems.map(function (item) {
        return new KliraCartCoupon(item.code, item.discountAmount);
      });
    }

    // remove any items that this customer cannot re-buy
    await this.emptyCartOfAlreadyPurchasedItems();
  },
};

// initialise the cart immediately
window.cart.init().then();
